<!-- //
dialog 大屏添加
@auth xuyd
@date 2024-05-03
//-->
<template>
  <el-dialog
      class="dialog-container"
      :title="title"
      :visible.sync="visible"
      :modal="true"
      :close-on-click-modal="false"
      :close-on-press-escape="true"
      :show-close="true"
      top="10vh"
      width="500px">
    <div>
      <el-form @submit.native.prevent ref="refForm" :model="form" :rules="rules" size="small" label-width="100px">
        <el-row class="flow-row">
          <el-form-item prop="pageName" label="大屏名称">
            <el-input size="small" v-model="form.pageName"/>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="hideModal">取 消</el-button>
      <el-button size="small" type="primary" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>

import DataScreenApi from '@/api/datavisual/dataScreen.api.js';

export default {
  name: 'ViewScreenAdd',
  data() {
    return {
      visible: false,
      title: '新建大屏',
      opts: {},
      form: {
        pageName: null,
      },
      rules: {
        pageName: [{required: true, message: "请输入大屏名称", trigger: 'blur'}],
      },
    }
  },
  methods: {
    showModal({data, onOk}) {
      let that = this;
      this.dialogShow({
        data: data,
        onOk(data) {
          let promise = onOk && onOk(data);
          if (promise) {
            promise.then(() => {
              that.hideModal();
            }).catch(err => {
              console.log(err)
            })
          }
        },
      })
    },
    dialogShow(opts) {
      this.visible = true;
      this.opts.onOk = opts.onOk
      this.opts.onCancel = opts.onCancel
      if (!opts.data) {
        opts.data = {};
      }
      opts.data = this.$util.mergeObject(this.form, opts.data)
      this.form = opts.data
    },

    hideModal() {
      this.visible = false;
      this.$refs["refForm"].clearValidate();
      this.$refs["refForm"].resetFields();
    },

    /**
     * 点击确定
     */
    handleOk() {
      let data = {...this.form};
      this.$refs.refForm.validate(valid => {
        if (valid) {
          data.width = data.width || 1920;
          data.height = data.height || 1080;
          data.backgroundColor = ""; // 大屏背景色
          data.refreshSeconds = null; // 大屏刷新时间间隔
          return DataScreenApi.saveScreen(data).then(resp => {
            this.$modal.msgSuccess("添加成功")
            this.opts.onOk(resp.data);
            this.hideModal();
          });
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
